import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { LocalPhone } from '@mui/icons-material';
import { green, grey } from '@mui/material/colors';
import { Box, Stack, Typography, Divider } from '@mui/material';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';

import { ActivityCardProps } from '../../types';
import { CallStatus } from './common/CallStatus';
import { FromToInfo } from './common/FromToInfo';
import { DealCallActivity } from '../../api/types';
import { CardContainer } from './common/CardContainer';
import { ActionDirection } from './common/ActionDirection';

export const CallCard = ({ entity, onDelete, onUpdate }: ActivityCardProps<DealCallActivity>) => {
  const classes = useStyles();

  const { topic, callDirection, callStatus, createdDateTime, participants, description } = entity;

  return (
    <CardContainer>
      <Box className={classes.callPhone}>
        <Box className="callIcon">
          <LocalPhone sx={{ color: 'white', zIndex: 2 }} />
          <ActionDirection isInternal={callDirection === 'INCOMING'} />
        </Box>

        <Stack gap="0.25rem">
          <Typography variant="h6" component="span">
            {topic}
          </Typography>

          <Stack direction="row" gap="0.5rem" alignItems="center">
            <CallStatus isAnswered={callStatus === 'ANSWERED'} />
            <FromToInfo participants={participants} actionDateTime={createdDateTime} actionName="Call" />
          </Stack>
        </Stack>

        <ActionsMenu
          config={[
            { action: onUpdate, label: 'Edit' },
            { action: onDelete, label: 'Delete', color: 'error' },
          ]}
        />
      </Box>

      <Divider />

      <Stack gap="0.3rem" sx={{ border: `1px solid ${grey[300]}`, borderRadius: '0.3rem', padding: '0.5rem' }}>
        <Typography variant="subtitle2" component="span">
          Notes
        </Typography>
        <Typography component="span" sx={{ wordBreak: 'break-all' }}>
          {description}
        </Typography>
      </Stack>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  callPhone: {
    gap: '1rem',
    width: '100%',
    display: 'grid',
    borderRadius: '0.5rem',
    alignItems: 'flex-start',
    gridTemplateColumns: 'auto 1fr auto',

    '& .callIcon': {
      display: 'flex',
      padding: '0.6rem',
      alignItems: 'center',
      borderRadius: '100%',
      position: 'relative',
      justifyContent: 'center',
      backgroundColor: green[500],
    },
  },
});
